export const UPLOADS_SERVER_URL = process.env.REACT_APP_UPLOAD_SERVER_URL
export const API_URL = process.env.REACT_APP_API_URL
